<div class="calendar-month">
    <div class="calendar-month__header">
        <ng-container *ngIf="position === 'left'">
            <button (click)="requestPrevYear.emit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12.9757 13.8047C13.21 14.0651 13.5899 14.0651 13.8243 13.8047C14.0586 13.5444 14.0586 13.1223 13.8243 12.8619L9.44853 8L13.8243 3.13807C14.0586 2.87772 14.0586 2.45561 13.8243 2.19526C13.5899 1.93491 13.21 1.93491 12.9757 2.19526L8.17573 7.5286C7.94142 7.78894 7.94142 8.21105 8.17573 8.4714L12.9757 13.8047ZM6.97573 13.8047C7.21005 14.0651 7.58995 14.0651 7.82426 13.8047C8.05858 13.5444 8.05858 13.1223 7.82426 12.8619L3.44853 8L7.82426 3.13807C8.05858 2.87772 8.05858 2.45561 7.82426 2.19526C7.58995 1.93491 7.21005 1.93491 6.97574 2.19526L2.17573 7.5286C1.94142 7.78895 1.94142 8.21105 2.17573 8.4714L6.97573 13.8047Z"
                        fill="#4D86BF" />
                </svg>

            </button> 
            <button (click)="requestPrevMonth.emit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.8423 13.7665C10.6184 14.0596 10.2388 14.0794 9.99456 13.8107L5.19456 8.53075C5.07059 8.39438 5 8.20182 5 8C5 7.79818 5.07059 7.60562 5.19456 7.46925L9.99456 2.18925C10.2388 1.92056 10.6184 1.94036 10.8423 2.23348C11.0662 2.52661 11.0497 2.98206 10.8054 3.25076L6.48793 8L10.8054 12.7492C11.0497 13.0179 11.0662 13.4734 10.8423 13.7665Z"
                        fill="#4D86BF" />
                </svg>
            </button> 
          </ng-container>
          


        <div class="month-title">     
             <span>{{ getMonthName(displayedMonth) }} {{ displayedYear }}</span>
        </div>
  

        <ng-container *ngIf="position === 'right'">
            <button (click)="requestNextMonth.emit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.17574 2.19526C5.41005 1.93491 5.78995 1.93491 6.02426 2.19526L10.8243 7.5286C11.0586 7.78895 11.0586 8.21105 10.8243 8.4714L6.02426 13.8047C5.78995 14.0651 5.41005 14.0651 5.17573 13.8047C4.94142 13.5444 4.94142 13.1223 5.17574 12.8619L9.55147 8L5.17574 3.13807C4.94142 2.87772 4.94142 2.45561 5.17574 2.19526Z"
                        fill="#4D86BF" />
                </svg></button>
            <button (click)="requestNextYear.emit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.02427 2.19526C2.78995 1.93491 2.41005 1.93491 2.17574 2.19526C1.94142 2.45561 1.94142 2.87772 2.17574 3.13807L6.55147 8L2.17574 12.8619C1.94142 13.1223 1.94142 13.5444 2.17574 13.8047C2.41005 14.0651 2.78995 14.0651 3.02426 13.8047L7.82427 8.47141C8.05858 8.21106 8.05858 7.78895 7.82427 7.5286L3.02427 2.19526ZM9.02427 2.19526C8.78995 1.93491 8.41005 1.93491 8.17574 2.19526C7.94142 2.45561 7.94142 2.87772 8.17574 3.13807L12.5515 8L8.17574 12.8619C7.94142 13.1223 7.94142 13.5444 8.17574 13.8047C8.41005 14.0651 8.78995 14.0651 9.02426 13.8047L13.8243 8.47141C14.0586 8.21106 14.0586 7.78895 13.8243 7.5286L9.02427 2.19526Z"
                        fill="#4D86BF" />
                </svg>
            </button>
        </ng-container>
    </div>

    <div class="calendar-month__weekdays">
        <div *ngFor="let day of weekDays">{{ day }}</div>
    </div>

    <div class="calendar-month__days">
        <div
            *ngFor="let day of days"
            (click)="!day.disabled && selectDate(day.date)"
            [class.outside]="day.outside"
            [class.selected]="isSelected(day.date)"
            [class.disabled]="day.disabled">
            {{ day.date.getDate() }}
        </div>
    </div>
</div>